import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextArea from '../common/form/labelAndTextarea';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import DateFormat from '../common/dateFormat/DateFormat';
import FormItem from './embalagemViagemItemForm';
import FormEvento from './embalagemViagemEventoForm';
import { setError } from '../common/toast/toast';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import imagemAdd from '../assets/images/icone_add_imagem.png';

import {
	setModoTela, initForm, finalizar, reabrir,
	setModoTelaItem, initFormItem, salvarItem, excluirItem, getListaItem, setListaItem, setListaEvento, getBuscarDatalake,
	getListaEventos, getListaLocalizacao, gerarComprovanteEntrega,
	setModoTelaEvento, initFormEvento, salvarEvento, excluirEvento,
	gerarPdfProForma, gerarPdfProFormaPackingList, gerarPdfPlanoCarga
} from './embalagemViagemActions';
import FormatUtils from '../common/formatUtils/FormatUtils';

class EmbalagemViagemForm extends Component {

	state = {

	}

	componentDidMount() {

		let initSeletorAnexoCRT = () => {
			const fileSelectorAnexoCRT = document.createElement('input');
			fileSelectorAnexoCRT.setAttribute('type', 'file');
			fileSelectorAnexoCRT.addEventListener("change", (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('application/pdf')
						&& !file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PDF, .PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {

						let lista = (this.props.formularioValues.anexo_crt || []).map(item => item);
						lista.push({
							anexo_crt_base64: reader.result
						});

						this.props.initForm({
							...this.props.formularioValues,
							anexo_crt: lista
						});

						initSeletorAnexoCRT();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorAnexoCRT = fileSelectorAnexoCRT;
		};

		initSeletorAnexoCRT();

		let initSeletorAnexoMIC = () => {
			const fileSelectorAnexoMIC = document.createElement('input');
			fileSelectorAnexoMIC.setAttribute('type', 'file');
			fileSelectorAnexoMIC.addEventListener("change", (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('application/pdf')
						&& !file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PDF, .PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {

						let lista = (this.props.formularioValues.anexo_mic || []).map(item => item);
						lista.push({
							anexo_mic_base64: reader.result
						});

						this.props.initForm({
							...this.props.formularioValues,
							anexo_mic: lista
						});

						initSeletorAnexoMIC();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorAnexoMIC = fileSelectorAnexoMIC;
		};

		initSeletorAnexoMIC();

		let initSeletorPdfAbertura = () => {
			const fileSelectorPdfAbertura = document.createElement('input');
			fileSelectorPdfAbertura.setAttribute('type', 'file');
			fileSelectorPdfAbertura.addEventListener("change", (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('application/pdf')
						&& !file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PDF, .PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {

						let lista = (this.props.formularioValues.pdf_abertura || []).map(item => item);
						lista.push({
							pdf_abertura_base64: reader.result
						});

						this.props.initForm({
							...this.props.formularioValues,
							pdf_abertura: lista
						});

						initSeletorPdfAbertura();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorPdfAbertura = fileSelectorPdfAbertura;
		};

		initSeletorPdfAbertura();

		let initSeletorPdfFechamento = () => {
			const fileSelectorPdfFechamento = document.createElement('input');
			fileSelectorPdfFechamento.setAttribute('type', 'file');
			fileSelectorPdfFechamento.addEventListener("change", (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('application/pdf')
						&& !file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PDF, .PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {

						let lista = (this.props.formularioValues.pdf_fechamento || []).map(item => item);
						lista.push({
							pdf_fechamento_base64: reader.result
						});

						this.props.initForm({
							...this.props.formularioValues,
							pdf_fechamento: lista
						});

						initSeletorPdfFechamento();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorPdfFechamento = fileSelectorPdfFechamento;
		};

		initSeletorPdfFechamento();

		let initSeletorImagem = () => {
			const fileSelectorImagem = document.createElement('input');
			fileSelectorImagem.setAttribute('type', 'file');
			fileSelectorImagem.addEventListener("change", (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas imagens (.PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {

						let lista = (this.props.formularioValues.imagem || []).map(item => item);
						lista.push({
							imagem_base64: reader.result
						});

						let imagemFonte = (this.props.formularioValues.imagem_fonte || []).map(item => item);
						imagemFonte.push('');

						this.props.initForm({
							...this.props.formularioValues,
							imagem: lista,
							imagem_fonte: imagemFonte
						});

						initSeletorImagem();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorImagem = fileSelectorImagem;
		};

		initSeletorImagem();

	}

    componentWillMount() {
		//Apenas Letsara
		this.props.getListaEventos(this.props.formularioValues ? this.props.formularioValues.id_transportadora : null, this.props.formularioValues ? this.props.formularioValues.id : null, this.props.formularioValues && this.props.formularioValues.id_transportadora == 1 ? this.props.formularioValues.solicitacao : null);
		this.props.getListaLocalizacao(this.props.formularioValues && this.props.formularioValues.id_transportadora == 1 ? this.props.formularioValues.solicitacao : null);
		this.props.getBuscarDatalake(this.props.formularioValues.solicitacao || 0);
    }

    render() {

		let readOnly = this.props.excluir || this.props.visualizacao || (this.props.formularioValues && this.props.formularioValues.id_status && ((this.props.formularioValues.id_status == 2 && !this.props.comprovantes) || this.props.formularioValues.id_status == 3)) ? 'readOnly' : '';

		let origem = this.props.listaEstoqueLocal.filter(item => item.id == this.props.formularioValues.id_origem)[0];
		let destino = this.props.listaEstoqueLocal.filter(item => item.id == this.props.formularioValues.id_destino)[0];

        return (
			<div>
				<ContentCard>
					<Form event={this.props.handleSubmit}>

						<ContentCardFooter>							
							<Row alignCenter>				
								<Grid cols='12 12 12 12'>
									<div style={{ textAlign: 'center' }}>
										{this.props.excluir ? (
											<a class={`btn btn-app bg-danger ${this.props.visualizacao ? 'disabled' : ''}`} style={{ marginLeft: 2, minWidth: 75 }}
												onClick={e => {
													if (!this.props.visualizacao) {
														e.preventDefault();
														this.props.onSubmit(this.props.formularioValues);
													}
												}}>
												<i class='fas fa-trash'></i> Cancelar
											</a>
										) : (!this.props.formularioValues || !this.props.formularioValues.id_status || this.props.formularioValues.id_status == 1 || (this.props.formularioValues.id_status == 2 && this.props.comprovantes) ? (
											<a class={`btn btn-app bg-success ${this.props.visualizacao ? 'disabled' : ''}`} style={{ marginLeft: 2, minWidth: 75 }}
												onClick={e => {
													if (!this.props.visualizacao) {
														e.preventDefault();
														this.props.onSubmit(this.props.formularioValues);
													}
												}}>
												<i class='fas fa-check'></i> Salvar
											</a>
										) : null)}

										{(this.props.sessao && !this.props.sessao.modoCliente && !this.props.sessao.modoTransportadora && !this.props.sessao.modoFornecedor) &&
										<>
											{(this.props.formularioValues.id && this.props.registroDataLake) &&
											<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
												onClick={() => {
													this.props.gerarPdfProForma(this.props.formularioValues, this.props.listaItem, this.props.registroDataLake || {});
												}}>
												<i class='fas fa-file'></i> Pro-Forma
											</a>}
											{(this.props.formularioValues.id && this.props.registroDataLake) &&
											<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
												onClick={() => {
													this.props.gerarPdfProFormaPackingList(this.props.formularioValues, this.props.listaItem, this.props.registroDataLake || {});
												}}>
												<i class='fas fa-file'></i> Packing List
											</a>}
											{(this.props.formularioValues.id && this.props.registroDataLake) &&
											<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
												onClick={() => {
													this.props.gerarPdfPlanoCarga(this.props.formularioValues, this.props.listaItem, this.props.registroDataLake || {});
												}}>
												<i class='fas fa-file'></i> Plano Carga
											</a>}

											<a class='btn btn-app bg-warning' style={{ marginLeft: 2, minWidth: 75 }}
												onClick={() => {
													this.props.setModoTela('lista');
												}}>
												<i class='fas fa-arrow-left'></i> Voltar
											</a>
										</>}
									</div>
								</Grid>
							</Row>
						</ContentCardFooter>

						<ContentCardBody>

							{!this.props.comprovantes ? (
								<>
									{(this.props.formularioValues && this.props.formularioValues.id) &&
									<Row>										
										<Select
											name='id_status'
											options={this.props.listaStatus}
											label='Status'
											cols='12 12 3 3'
											placeholder='Selecione o status'
											readOnly={'readOnly'}
											value={this.props.formularioValues.id_status}
											onChange={data => {
												if (data) {
													this.props.initForm({
														...this.props.formularioValues,
														id_status: data
													});
												}
											}} />
										
										<Field
											name='datahora_viagem'
											component={LabelAndInputMask}
											label='Data/Hora' placeholder='Informe a data e hora da viagem'
											cols='12 6 3 3'
											mask='99/99/9999 99:99'
											readOnly={readOnly} />

										{this.props.formularioValues && this.props.formularioValues.datahora_finalizacao ? (
											<Field
												name='datahora_finalizacao'
												component={LabelAndInputMask}
												label='Finalização' placeholder='Informe a data e hora da finalização'
												cols='12 6 3 3'
												mask='99/99/9999 99:99'
												readOnly={readOnly} />
										) : null}										
									</Row>}
									<Row>
										<Select
											name='id_transportadora'
											options={this.props.listaTransportadora}
											label='Transportadora'
											cols='12 12 12 12'
											placeholder='Selecione a transportadora'
											readOnly={readOnly ? readOnly : (this.props.formularioValues.id ? 'readOnly' : (this.props.sessao.id_transportadora ? 'readOnly' : null))}
											value={this.props.formularioValues.id_transportadora}
											onChange={data => {
												if (data) {
													this.props.initForm({
														...this.props.formularioValues,
														id_transportadora: data
													});
												}
											}} />

										<Field
											name='viagem'
											component={LabelAndInputNumber}
											label='Viagem' placeholder='Informe a viagem'
											cols='12 6 4 4'
											casas={0}
											readOnly='readOnly' />

										<Field
											name='solicitacao'
											component={LabelAndInput}
											label='Solicitação' placeholder='Informe a solicitacao'
											cols='12 6 4 4'
											casas={0}
											readOnly={readOnly} />

										<Field
											name='fatura'
											component={LabelAndInput}
											label='Fatura' placeholder='Informe a fatura'
											cols='12 6 4 4'
											casas={0}
											readOnly={readOnly} />

										<Field
											name='conhecimento_transporte'
											component={LabelAndInput}
											label='CRT' placeholder='Informe o número'
											cols='12 6 4 4'
											readOnly={readOnly} />

										<Field
											name='mic'
											component={LabelAndInput}
											label='MIC' placeholder='Informe o número'
											cols='12 6 4 4'
											readOnly={readOnly} />

										<Field
											name='carga_manual'
											component={LabelAndInput}
											label='Embarque GMA' placeholder='Informe o número'
											cols='12 6 4 4'
											readOnly={readOnly} />
									</Row>
									<Row>
										<Field
											name='cavalo'
											component={LabelAndInput}
											label='Cavalo' placeholder='Informe a placa'
											cols='12 6 4 4'
											readOnly={readOnly} />

										<Field
											name='carreta1'
											component={LabelAndInput}
											label='Carreta 1' placeholder='Informe a placa'
											cols='12 6 4 4'
											readOnly={readOnly} />

										<Field
											name='carreta2'
											component={LabelAndInput}
											label='Carreta 2' placeholder='Informe a placa'
											cols='12 6 4 4'
											readOnly={readOnly} />
									</Row>
									<Row>
										<Select
											name='id_origem'
											options={this.props.listaEstoqueLocal}
											label='Origem'
											cols='12 12 6 6'
											placeholder='Selecione o local'
											readOnly={readOnly}
											value={this.props.formularioValues.id_origem}
											onChange={data => {
												if (data) {
													this.props.initForm({
														...this.props.formularioValues,
														id_origem: data,
														id_fornecedor_origem: null
													});
												}
											}} />

										{this.props.formularioValues.id_origem == 2 ? ( //Se a origem da embalagem é o fornecedor
											<Select
												name='id_fornecedor_origem'
												options={this.props.listaFornecedor.filter(item => this.props.formularioValues.id_transportadora && item.transportadoras.includes(this.props.formularioValues.id_transportadora))}
												label='Fornecedor de Origem'
												cols='12 12 6 6'
												placeholder='Selecione o fornecedor de origem'
												readOnly={readOnly}
												value={this.props.formularioValues.id_fornecedor_origem}
												onChange={data => {
													if (data) {
														this.props.initForm({
															...this.props.formularioValues,
															id_fornecedor_origem: data
														});
													}
												}} />
										) : null}

									</Row>
									<Row>

										<Select
											name='id_destino'
											options={this.props.listaEstoqueLocal}
											label='Destino'
											cols='12 12 6 6'
											placeholder='Selecione o local'
											readOnly={readOnly}
											value={this.props.formularioValues.id_destino}
											onChange={data => {
												if (data) {
													this.props.initForm({
														...this.props.formularioValues,
														id_destino: data,
														id_fornecedor_destino: null
													});
												}
											}} />

										{this.props.formularioValues.id_destino == 2 ? ( //Se o destino da embalagem é o fornecedor
											<Select
												name='id_fornecedor_destino'
												options={this.props.listaFornecedor.filter(item => this.props.formularioValues.id_transportadora && item.transportadoras.includes(this.props.formularioValues.id_transportadora))}
												label='Fornecedor de Destino'
												cols='12 12 6 6'
												placeholder='Selecione o fornecedor de destino'
												readOnly={readOnly}
												value={this.props.formularioValues.id_fornecedor_destino}
												onChange={data => {
													if (data) {
														this.props.initForm({
															...this.props.formularioValues,
															id_fornecedor_destino: data
														});
													}
												}} />
										) : null}

									</Row>

									<Row>
										<Select
											name='id_plano_carga'
											options={this.props.listaPlanoCarga}
											label='Plano de Carga'
											cols='12 12 6 6'
											placeholder='Selecione o plano de carga'
											readOnly={readOnly}
											value={this.props.formularioValues.id_plano_carga}
											onChange={data => {
												this.props.initForm({
													...this.props.formularioValues,
													id_plano_carga: data
												});
											}} />
									</Row>

									<Row>
										<LabelAndInput
											label='Localização' placeholder='Informe'
											cols='12 12 12 12'
											value={this.props.localizacao ? this.props.localizacao.descricao : (this.props.formularioValues.localizacao)}
											onChange={() => {}}
											readOnly={'readOnly'} />

										<Field
											name='observacao'
											component={LabelAndTextArea}
											label='Observação' placeholder='Informe'
											cols='12 12 12 12'
											readOnly={readOnly} />
									</Row>

									<Row>
										<Grid cols='12 12 12 12'>
											<label>Anexo CRT</label>
										</Grid>
										{(this.props.formularioValues.anexo_crt || []).map(arquivo => (
											<div style={{ display: 'flex', flexDirection: 'column', marginLeft: 6 }}>
												<span class="btn btn-outline-primary fileinput-button dz-clickable">
													<img src={arquivo.anexo_crt_base64 ? pdfAdicionado : (arquivo.pdf ? pdfAdicionado : pdfAdd)} style={{ height: 30 }} />
												</span>
												<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
													<button
														type='button'
														class='btn btn-flat btn-outline-primary'
														style={{ width: '48%' }}
														disabled={arquivo.anexo_crt_base64 ?true : false}
														onClick={() => {
															window.open(`https://api-letsarareports.infinitum-ti.com/${arquivo.pdf}`, '_blank');
														}}>
														<i class='fas fa-download'></i>
													</button>

													<button
														type='button'
														class='btn btn-flat btn-outline-danger'
														style={{ width: '48%' }}
														disabled={readOnly}
														onClick={() => {
															this.props.initForm({
																...this.props.formularioValues,
																anexo_crt: this.props.formularioValues.anexo_crt.filter(item => item != arquivo)
															});
														}}>
														<i class='fas fa-trash-alt'></i>
													</button>
												</div>
											</div>
										))}
										{!readOnly ? (
											<span class="btn btn-outline-primary fileinput-button dz-clickable" 
												style={{ marginLeft: 6 }}
												onClick={() => this.fileSelectorAnexoCRT.click()}>
												<img src={pdfAdd} style={{ height: 30 }} />
											</span>
										) : null}
									</Row>

									<br />

									<Row>
										<Grid cols='12 12 12 12'>
											<label>Anexo MIC</label>
										</Grid>
										{(this.props.formularioValues.anexo_mic || []).map(arquivo => (
											<div style={{ display: 'flex', flexDirection: 'column', marginLeft: 6 }}>
												<span class="btn btn-outline-primary fileinput-button dz-clickable">
													<img src={arquivo.anexo_mic_base64 ? pdfAdicionado : (arquivo.pdf ? pdfAdicionado : pdfAdd)} style={{ height: 30 }} />
												</span>
												<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
													<button
														type='button'
														class='btn btn-flat btn-outline-primary'
														style={{ width: '48%' }}
														disabled={arquivo.anexo_mic_base64 ?true : false}
														onClick={() => {
															window.open(`https://api-letsarareports.infinitum-ti.com/${arquivo.pdf}`, '_blank');
														}}>
														<i class='fas fa-download'></i>
													</button>

													<button
														type='button'
														class='btn btn-flat btn-outline-danger'
														style={{ width: '48%' }}
														disabled={readOnly}
														onClick={() => {
															this.props.initForm({
																...this.props.formularioValues,
																anexo_mic: this.props.formularioValues.anexo_mic.filter(item => item != arquivo)
															});
														}}>
														<i class='fas fa-trash-alt'></i>
													</button>
												</div>
											</div>
										))}
										{!readOnly ? (
											<span class="btn btn-outline-primary fileinput-button dz-clickable" 
												style={{ marginLeft: 6 }}
												onClick={() => this.fileSelectorAnexoMIC.click()}>
												<img src={pdfAdd} style={{ height: 30 }} />
											</span>
										) : null}
									</Row>
									
									<br />

									<Row>
										<Grid cols='12 12 12 12'>
											<label>Packing list de abertura</label>
										</Grid>
										{(this.props.formularioValues.pdf_abertura || []).map(arquivo => (
											<div style={{ display: 'flex', flexDirection: 'column', marginLeft: 6 }}>
												<span class="btn btn-outline-primary fileinput-button dz-clickable">
													<img src={arquivo.pdf_abertura_base64 ? pdfAdicionado : (arquivo.pdf ? pdfAdicionado : pdfAdd)} style={{ height: 30 }} />
												</span>
												<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
													<button
														type='button'
														class='btn btn-flat btn-outline-primary'
														style={{ width: '48%' }}
														disabled={arquivo.pdf_abertura_base64 ?true : false}
														onClick={() => {
															window.open(`https://api-letsarareports.infinitum-ti.com/${arquivo.pdf}`, '_blank');
														}}>
														<i class='fas fa-download'></i>
													</button>

													<button
														type='button'
														class='btn btn-flat btn-outline-danger'
														style={{ width: '48%' }}
														disabled={readOnly}
														onClick={() => {
															this.props.initForm({
																...this.props.formularioValues,
																pdf_abertura: this.props.formularioValues.pdf_abertura.filter(item => item != arquivo)
															});
														}}>
														<i class='fas fa-trash-alt'></i>
													</button>
												</div>
											</div>
										))}
										{!readOnly ? (
											<span class="btn btn-outline-primary fileinput-button dz-clickable" 
												style={{ marginLeft: 6 }}
												onClick={() => this.fileSelectorPdfAbertura.click()}>
												<img src={pdfAdd} style={{ height: 30 }} />
											</span>
										) : null}
									</Row>
								</>
							) : null}

							{(!readOnly && this.props.comprovantes) &&
							<br />}
							{(!readOnly && this.props.comprovantes) &&
							<Row>
								<Grid cols='12 12 12 12'>
									<label>Comprovante de entrega/fechamento</label>
								</Grid>
								{(this.props.formularioValues.pdf_fechamento || []).map(arquivo => (
									<div style={{ display: 'flex', flexDirection: 'column', marginLeft: 6 }}>
										<span class="btn btn-outline-primary fileinput-button dz-clickable">
											<img src={arquivo.pdf_fechamento_base64 ? pdfAdicionado : (arquivo.pdf ? pdfAdicionado : pdfAdd)} style={{ height: 30 }} />
										</span>
										<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
											<button
												type='button'
												class='btn btn-flat btn-outline-primary'
												style={{ width: '48%' }}
												disabled={arquivo.pdf_fechamento_base64 ? true : false}
												onClick={() => {
													window.open(`https://api-letsarareports.infinitum-ti.com/${arquivo.pdf}`, '_blank');
												}}>
												<i class='fas fa-download'></i>
											</button>

											<button
												type='button'
												class='btn btn-flat btn-outline-danger'
												style={{ width: '48%' }}
												disabled={readOnly || !this.props.comprovantes}
												onClick={() => {
													this.props.initForm({
														...this.props.formularioValues,
														pdf_fechamento: this.props.formularioValues.pdf_fechamento.filter(item => item != arquivo)
													});
												}}>
												<i class='fas fa-trash-alt'></i>
											</button>
										</div>
									</div>
								))}

								<span class="btn btn-outline-primary fileinput-button dz-clickable" 
									style={{ marginLeft: 6 }}
									onClick={() => this.fileSelectorPdfFechamento.click()}>
									<img src={pdfAdd} style={{ height: 30 }} />
								</span>
							</Row>}

							<br />

							<Row>
								<Grid cols='12 12 12 12'>
									<label>Fotos da Carga</label>
								</Grid>
								{(this.props.formularioValues.imagem || []).map((arquivo, i) => (
									<div style={{ display: 'flex', flexDirection: 'column', marginLeft: 6 }}>
										<span class="btn btn-outline-primary fileinput-button dz-clickable">
											<img src={arquivo.imagem_base64 ? arquivo.imagem_base64 : (arquivo.imagem ? `https://api-letsarareports.infinitum-ti.com/${arquivo.imagem}` : imagemAdd)} style={{ height: 30 }} />
										</span>
										<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
											<button
												type='button'
												class='btn btn-flat btn-outline-primary'
												style={{ width: '48%' }}
												disabled={arquivo.imagem_base64 ? true : false}
												onClick={() => {
													window.open(`https://api-letsarareports.infinitum-ti.com/${arquivo.imagem}`, '_blank');
												}}>
												<i class='fas fa-download'></i>
											</button>

											<button
												type='button'
												class='btn btn-flat btn-outline-danger'
												style={{ width: '48%' }}
												disabled={readOnly}
												onClick={() => {
													this.props.initForm({
														...this.props.formularioValues,
														imagem: this.props.formularioValues.imagem.filter(item => item != arquivo)
													});
												}}>
												<i class='fas fa-trash-alt'></i>
											</button>
										</div>
									</div>
								))}

								{!readOnly ? (
									<span class="btn btn-outline-primary fileinput-button dz-clickable" 
										style={{ marginLeft: 6 }}
										onClick={() => this.fileSelectorImagem.click()}>
										<img src={imagemAdd} style={{ height: 30 }} />
									</span>
								) : null}
							</Row>
						</ContentCardBody>

					</Form>
				</ContentCard>
				{this.props.formularioValues.id && !this.props.comprovantes ?
					this.renderItens(readOnly)
					: null
				}
				{this.props.formularioValues.id && !this.props.comprovantes ?
					this.renderEventos(readOnly)
					: null
				}

				{this.props.formularioValues.id && this.props.visualizacao && !this.props.comprovantes ?
					this.renderHistorico()
					: null
				}

			</div>
        )
    }

	renderItens(readOnly) {

		if (this.props.modoTelaItem == 'cadastro') {
			return (
				<FormItem onSubmit={this.props.salvarItem} />
			);
		} else if (this.props.modoTelaItem == 'exclusao') {
			return (
				<FormItem excluir onSubmit={this.props.excluirItem} />
			);
		} else if (this.props.modoTelaItem == 'lista') {
			return (

				<ContentCard>
					<ContentCardHeader>
						<Row>
							<Grid cols='6 6 4 2'>
								{this.props.formularioValues && this.props.formularioValues.id_status == 1 ? (
									<Button
										text='Adicionar'
										type={'success'}
										icon={'fa fa-plus'}
										disabled={readOnly ? true : false}
										event={() => {
											this.props.setModoTelaItem('cadastro', {
												id_viagem: this.props.formularioValues.id,
												id_transportadora: this.props.formularioValues.id_transportadora
											});
											this.props.initFormItem({
												id_viagem: this.props.formularioValues.id,
												id_transportadora: this.props.formularioValues.id_transportadora
											});
										}} />
								) : null}
							</Grid>
						</Row>
					</ContentCardHeader>
					<ContentCardBody>
						<Table responsive>
							<THead>
								<Tr>
									<Th alignCenter width={500}>Embalagem</Th>
									<Th alignCenter width={100}>Quantidade</Th>
									<Th alignCenter width={100}>Preço Unitário</Th>
									<Th alignCenter width={80}></Th>
								</Tr>
							</THead>
							<TBody>
								{this.props.listaItem.map(item => (
									<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
										onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td alignCenter>{item.nome_embalagem}</Td>
										<Td alignCenter>{parseInt(item.quantidade || 0)}</Td>
										<Td alignCenter>{FormatUtils.formatarValorTela(item.preco_unitario || 0, 2)}</Td>
										<Td alignCenter minWidth={80}>
											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={true}
												disabled={readOnly ? true : false}
												event={() => {
													this.props.setModoTelaItem('cadastro', {
														...item,
														quantidade: String(item.quantidade || '').replace('.', ',')
													});
													this.props.initFormItem({
														...item,
														quantidade: String(item.quantidade || '').replace('.', ',')
													});
												}} />

											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={true}
												disabled={readOnly ? true : false}
												event={() => {
													this.props.setModoTelaItem('exclusao', {
														...item,
														quantidade: String(item.quantidade || '').replace('.', ',')
													});
													this.props.initFormItem({
														...item,
														quantidade: String(item.quantidade || '').replace('.', ',')
													});
												}} />
										</Td>
									</Tr>
								))}
							</TBody>
						</Table>
					</ContentCardBody>
				</ContentCard>
			);
		} else {
			return (
				<div></div>
			);
		}
	}

	renderEventos(readOnly) {

		if (this.props.modoTelaEvento == 'cadastro') {
			return (
				<FormEvento onSubmit={this.props.salvarEvento} />
			);
		} else if (this.props.modoTelaEvento == 'exclusao') {
			return (
				<FormEvento excluir onSubmit={this.props.excluirEvento} />
			);
		} else if (this.props.modoTelaEvento == 'lista') {

			return (

				<ContentCard>
					<ContentCardHeader>
						<Row>
							<Grid cols='6 6 4 2'>
								{this.props.formularioValues && this.props.formularioValues.id_status == 1 ? (
									<Button
										text='Adicionar'
										type={'success'}
										icon={'fa fa-plus'}
										disabled={readOnly ? true : false}
										event={() => {
											this.props.setModoTelaEvento('cadastro', {
												id_viagem: this.props.formularioValues.id,
												cavalo: this.props.listaEventos[this.props.listaEventos.length -1] ? this.props.listaEventos[this.props.listaEventos.length -1].cavalo : this.props.formularioValues.cavalo,
												carretas: this.props.listaEventos[this.props.listaEventos.length -1] ? this.props.listaEventos[this.props.listaEventos.length -1].carretas : `${this.props.formularioValues.carreta1 || ''}${this.props.formularioValues.carreta2 ? ', ' : ''}${this.props.formularioValues.carreta2 || ''}`
											});
											this.props.initFormEvento({
												id_viagem: this.props.formularioValues.id,
												cavalo: this.props.listaEventos[this.props.listaEventos.length -1] ? this.props.listaEventos[this.props.listaEventos.length -1].cavalo : this.props.formularioValues.cavalo,
												carretas: this.props.listaEventos[this.props.listaEventos.length -1] ? this.props.listaEventos[this.props.listaEventos.length -1].carretas : `${this.props.formularioValues.carreta1 || ''}${this.props.formularioValues.carreta2 ? ', ' : ''}${this.props.formularioValues.carreta2 || ''}`
											});
										}} />
								) : null}
							</Grid>
						</Row>
					</ContentCardHeader>
					<ContentCardBody>
						<Table responsive>
							<THead>
								<Tr>
									<Th alignCenter width={200}>Data/Hora</Th>
									<Th alignCenter width={400}>Evento</Th>
									<Th alignCenter width={100}>Cavalo</Th>
									<Th alignCenter width={100}>Carretas</Th>
									<Th alignCenter width={80}></Th>
								</Tr>
							</THead>
							<TBody>
								{this.props.listaEventos.map(item => (
									<Tr key={item.id}>
										<Td alignCenter>{item.id_tipo ? DateFormat.formatarDataHoraSqlParaTela(item.datahora_evento) : item.datahora_evento}</Td>
										<Td alignCenter>{item.nome_evento}</Td>
										<Td alignCenter>{item.cavalo}</Td>
										<Td alignCenter>{item.carretas}</Td>
										<Td alignCenter minWidth={80}>
											{item.id_tipo ? (
												<ButtonTable
													type={'warning'}
													icon={'fas fa-pencil-alt'}
													visible={true}
													disabled={readOnly ? true : false}
													event={() => {
														this.props.setModoTelaEvento('cadastro', {
															...item,
															datahora_evento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_evento)
														});
														this.props.initFormEvento({
															...item,
															datahora_evento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_evento)
														});
													}} />
											) : null}
											{item.id_tipo ? (
												<ButtonTable
													type={'danger'}
													icon={'fas fa-trash-alt'}
													visible={true}
													disabled={readOnly ? true : false}
													event={() => {
														this.props.setModoTelaEvento('exclusao', {
															...item,
															datahora_evento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_evento)
														});
														this.props.initFormEvento({
															...item,
															datahora_evento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_evento)
														});
													}} />
											) : null}
										</Td>
									</Tr>
								))}
							</TBody>
						</Table>
					</ContentCardBody>
				</ContentCard>
			);
		}
	}

	renderHistorico() {

		return (

			<ContentCard>
				<ContentCardHeader>
					<label>Históricos</label>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter width={200}>Data/Hora</Th>
								<Th alignCenter width={500}>Usuário</Th>
								<Th alignCenter width={100}></Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.listaHistorico.map(item => (
								<Tr key={item.id}>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_alteracao)}</Td>
									<Td alignCenter>{item.nome_usuario_alteracao}</Td>
									<Td alignCenter minWidth={80}>
										<ButtonTable
											type={'success'}
											icon={'fas fa-code-branch'}
											visible={true}
											event={() => {
												this.props.setModoTela('visualizacao', {
													...item.registro,
													datahora_viagem: DateFormat.formatarDataHoraSqlParaTela(item.registro.datahora_viagem),
													datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.registro.datahora_finalizacao)
												});
												this.props.initForm({
													...item.registro,
													datahora_viagem: DateFormat.formatarDataHoraSqlParaTela(item.registro.datahora_viagem),
													datahora_finalizacao: DateFormat.formatarDataHoraSqlParaTela(item.registro.datahora_finalizacao)
												});
												console.log(item);
												this.props.setListaItem(item.itens || []);
												this.props.setListaEvento(item.eventos || []);
												window.scrollTo(0, 0);
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);

	}

}

EmbalagemViagemForm = reduxForm({form: 'embalagemViagemForm', destroyOnUnmount: false})(EmbalagemViagemForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('embalagemViagemForm')(state),
	registro: state.embalagemViagem.registro,
	registroDataLake: state.embalagemViagem.registroDataLake,
	listaItem: state.embalagemViagem.listaItem,
	cliente: state.cliente.lista.filter(item => item.id == state.auth.usuario.id_cliente)[0],
	listaTransportadora: state.embalagemViagem.listaTransportadora,
	listaFornecedor: state.embalagemViagem.listaFornecedor,
	listaEmbalagem: state.embalagemViagem.listaEmbalagem,
	listaPlanoCarga: state.embalagemViagem.listaPlanoCarga,
	listaEstoqueLocal: state.embalagemViagem.listaEstoqueLocal,
	listaStatus: state.embalagemViagem.listaStatus,
	listaSentido: state.embalagemViagem.listaSentido,
	listaEventos: state.embalagemViagem.listaEventos,
	listaHistorico: state.embalagemViagem.listaHistorico,
	localizacao: state.embalagemViagem.localizacao,
	modoTelaItem: state.embalagemViagem.modoTelaItem,
	modoTelaEvento: state.embalagemViagem.modoTelaEvento
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, finalizar, reabrir,
	setModoTelaItem, initFormItem, salvarItem, excluirItem, getListaItem, setListaItem, setListaEvento, getBuscarDatalake,
	getListaEventos, getListaLocalizacao, gerarComprovanteEntrega,
	setModoTelaEvento, initFormEvento, salvarEvento, excluirEvento,
	gerarPdfProForma, gerarPdfProFormaPackingList, gerarPdfPlanoCarga
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(EmbalagemViagemForm);
